import axios from "axios";
import { useEffect, useState } from "react";
import { Accordion, Breadcrumb, Col, Container, Row } from "react-bootstrap";
import microsoftAuthorizedReseller from "../../../Assets/images/microsoft_authorized_reseller.png";
import wordImg from "../../../Assets/images/logos/word.svg";
import excelImg from "../../../Assets/images/logos/excel.svg";
import powerpointImg from "../../../Assets/images/logos/powerpoint.svg";
import noteImg from "../../../Assets/images/logos/oneNote.svg";

import wordhead from "../../../Assets/images/wordhead.png";
import excelhead from "../../../Assets/images/excelhead.png";
import powerpointhead from "../../../Assets/images/powerpointhead.png";
import notehead from "../../../Assets/images/notehead.png";

import { useNavigate } from "react-router-dom";
import { apiBaseURL } from "../../../Common/ApiHelper";
import { ToastContainer, toast } from "react-toastify";

const OfficeStudentMac = ({ id }) => {
  const navigate = useNavigate();
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [cart, setCart] = useState([]);
  const [added, setAdded] = useState(
    localStorage.getItem("addedProducts")
      ? localStorage.getItem("addedProducts")
      : []
  );

  const fetchData = async () => {
    try {
      const response = await axios({
        method: "get",
        url: `${apiBaseURL}user/getProductById/?productId=${id}`,
      });
      if (response?.status === 200) {
        setTableData(response.data.data);
        setLoading(false);
      }
    } catch (e) {
      toast.error(e.message);
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);
  useEffect(() => {
    if (localStorage.getItem("cartItems")) {
      setCart(JSON.parse(localStorage.getItem("cartItems")));
    } else {
      localStorage.setItem("cartItems", JSON.stringify([]));
    }
  }, []);
  const handleAddCart = (product) => {
    product.quantity = 1;
    localStorage.setItem("cartItems", JSON.stringify([...cart, product]));
    setCart([...cart, product]);
    const updatedArray = JSON.parse(localStorage.getItem("cartItems")).map(
      (items) => items._id
    );
    setAdded(updatedArray);
    localStorage.setItem("addedProducts", JSON.stringify(updatedArray));
    toast.info("Product Added", {
      position: "top-right",
      autoClose: 100,
      hideProgressBar: true,
      closeOnClick: false,
      pauseOnHover: false,
      draggable: false,
      progress: undefined,
      theme: "light",
    });
    navigate(`${window.location.pathname}`);
  };
  return (
    <>
      <ToastContainer />
      <div className="main pt-4 pb-5">
        <Container>
          <div className="product_breadcrumb">
            <Breadcrumb>
              <Breadcrumb.Item onClick={() => navigate("/")}>
                Home
              </Breadcrumb.Item>
              <Breadcrumb.Item
                onClick={() => navigate("/category/MicrosoftOffice")}
              >
                Shop
              </Breadcrumb.Item>
              <Breadcrumb.Item active>
                Microsoft Office 2021 Home and Student (For Mac)
              </Breadcrumb.Item>
            </Breadcrumb>
          </div>
          {loading ? (
            <>
              <div class="d-flex justify-content-center ">
                <div class="spinner-grow text-secondary mx-1" role="status">
                  <span class="sr-only"></span>
                </div>
                <div class="spinner-grow text-secondary mx-1" role="status">
                  <span class="sr-only"></span>
                </div>
                <div class="spinner-grow text-secondary mx-1" role="status">
                  <span class="sr-only"></span>
                </div>
                <div class="spinner-grow text-secondary mx-1" role="status">
                  <span class="sr-only"></span>
                </div>
                <div class="spinner-grow text-secondary mx-1" role="status">
                  <span class="sr-only"></span>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="product_details_with_image box_shadow">
                <Row>
                  <Col xxl="3" lg="3" md="12">
                    <div className="product_image pt-4">
                      <img
                        src={tableData.productImage}
                        alt="Product"
                        style={{ width: "100%" }}
                      />
                    </div>
                  </Col>
                  <Col xxl="7" lg="7" md="12">
                    <div className="product_details pt-5 pb-4">
                      {tableData.device ? (
                        <>
                          <h1>
                            {tableData.name.split("For")[0]}
                            <span className="other_product_title">
                              {tableData.device}
                            </span>
                          </h1>
                        </>
                      ) : (
                        tableData.name
                      )}
                      <p className="retail_version_color">
                        Retail Version |{" "}
                        {tableData?.retailVersion[0]?.split(":").join(": ")}
                      </p>
                      <img
                        src={wordhead}
                        alt="Product inner products images"
                        className="mb-4 px-2"
                      />
                      <img
                        src={excelhead}
                        alt="Product inner products images"
                        className="mb-4 px-2"
                      />
                      <img
                        src={powerpointhead}
                        alt="Product inner products images"
                        className="mb-4 px-2"
                      />
                      <img
                        src={notehead}
                        alt="Product inner products images"
                        className="mb-4 px-2"
                      />
                      <div className="include_product_purchase">
                        <h1 className="font-weight-bold">
                          Included In Your Purchase:
                        </h1>
                        <p>
                          Classic 2021 Versions Of Word, Excel, Powerpoint, and
                          OneNote <br />
                          Microsoft Office 2021 Home and Student (For Mac)
                          License Key <br />
                          PDF - Download & Activation Guide
                          <br />
                          Live Chat Support & Assistance
                        </p>
                      </div>
                    </div>
                  </Col>
                  <Col xxl="2" lg="2" md="12">
                    <div className="price_details pt-5 pb-4">
                      <p className="font-weight-bold product_price mb-0">
                        ${tableData.salePrice} USD
                      </p>
                      {added.includes(tableData._id) ? (
                        <button
                          className="product_page_addCart_btn box_shadow"
                          onClick={() => navigate("/cart")}
                        >
                          Go To Cart
                        </button>
                      ) : (
                        <button
                          className="product_page_addCart_btn box_shadow"
                          onClick={() => handleAddCart(tableData)}
                        >
                          Add To Cart
                        </button>
                      )}

                      <div className="product_have_questions">
                        <h3>Have Questions?</h3>
                        <p>
                          Call +1 (833) 465 0300 <br /> or contact us via chat
                        </p>
                      </div>
                      <div className="microsoft_partner">
                        <img
                          src={microsoftAuthorizedReseller}
                          alt="productgroupImg"
                        />
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </>
          )}

          <div className="extraInfo_tabs mt-4 ">
            <Row>
              <Col xxl="2" xl="2" lg="4" sm="6">
                <div className="info_tab blue_bg text-center mb-4">
                  <h5>Licensing</h5>
                  <p className="mb-0">Retail</p>
                </div>
              </Col>
              <Col xxl="2" xl="2" lg="4" sm="6">
                <div className="info_tab blue_bg text-center mb-4">
                  <h5>Licensing Term</h5>
                  <p className="mb-0">Lifetime</p>
                </div>
              </Col>
              <Col xxl="2" xl="2" lg="4" sm="6">
                <div className="info_tab blue_bg text-center mb-4">
                  <h5>Users Supported</h5>
                  <p className="mb-0">1 User </p>
                </div>
              </Col>
              <Col xxl="2" xl="2" lg="4" sm="6">
                <div className="info_tab blue_bg text-center mb-4">
                  <h5>Devices Supported</h5>
                  <p className="mb-0">1 Device </p>
                </div>
              </Col>
              <Col xxl="2" xl="2" lg="4" sm="6">
                <div className="info_tab blue_bg text-center mb-4">
                  <h5>Delivery Method</h5>
                  <p className="mb-0">Instant Digital Delivery</p>
                </div>
              </Col>
              <Col xxl="2" xl="2" lg="4" sm="6">
                <div className="info_tab blue_bg text-center mb-4   ">
                  <h5>Platform Supported</h5>
                  <p className="mb-0">Windows</p>
                </div>
              </Col>
            </Row>
          </div>
          <div className="product_long_description">
            <Row>
              <Col xxl="9" md="9" sm="12">
                <div className="box_shadow product_main_description mb-2 me-3">
                  <h3>Product Description</h3>
                  <p className="microsoft_description mb-4">
                    Microsoft Office 2021 Home and Student is a powerful
                    productivity suite designed for students and home users. It
                    includes the essential programs needed to create
                    professional documents, presentations, and spreadsheets,
                    including Word, PowerPoint, and Excel. This version of
                    Office is designed to be easy to use, with a user-friendly
                    interface that makes it simple for users of all skill levels
                    to get started and be productive right away.
                    <br />
                    <br />
                    One of the standout features of Office 2021 Home and Student
                    is its compatibility with other devices and platforms. Users
                    can easily share and collaborate on documents with other
                    users, as well as with Windows and mobile device users. This
                    makes it an ideal tool for students who need to work on
                    group projects or collaborate with classmates.
                  </p>
                  <div className="proDescription_other_products mt-3 mb-3">
                    <Row>
                      <Col xl="2">
                        <div className="text-center">
                          <img src={wordImg} alt="Word Logo" />
                        </div>
                      </Col>
                      <Col xl="10 d-flex flex-column justify-content-center">
                        <p className="microsoft_description">
                          <span className="other_product_title">
                            Word 2021 (For Mac)
                          </span>{" "}
                          is a powerful word-processing application that offers
                          a range of features that help users create
                          professional documents easily. With its wide range of
                          fonts and design tools, Word 2021 for Professional
                          allows users to customize their documents to suit
                          their specific needs. In addition, the software's
                          real-time collaboration feature makes it easy for
                          users to work on the same document simultaneously,
                          which is particularly useful for group projects and
                          collaborative assignments.
                        </p>
                      </Col>
                    </Row>
                  </div>
                  <div className="proDescription_other_products mb-3">
                    <Row>
                      <Col xl="2">
                        <div className="text-center ">
                          <img src={excelImg} alt="excel logo" />
                        </div>
                      </Col>
                      <Col xl="10 d-flex flex-column justify-content-center">
                        <p className="microsoft_description">
                          <span className="other_product_title">
                            Excel 2021 (For Mac)
                          </span>{" "}
                          is a versatile spreadsheet application that enables
                          users to perform complex calculations and organize
                          data more effectively. With its wide range of charting
                          and graphing tools, Excel 2021 for Professional allows
                          users to visualize their data more easily, making it
                          easier to spot trends and patterns. In addition, the
                          software's pivot table feature is a powerful tool for
                          analyzing large amounts of data quickly and
                          efficiently.
                        </p>
                      </Col>
                    </Row>
                  </div>

                  <div className="proDescription_other_products mb-3">
                    <Row>
                      <Col xl="2">
                        <div className="text-center ">
                          <img src={powerpointImg} alt="powerpointImg" />
                        </div>
                      </Col>
                      <Col xl="10 d-flex flex-column justify-content-center">
                        <p className="microsoft_description">
                          <span className="other_product_title">
                            PowerPoint 2021 (For Mac)
                          </span>{" "}
                          is a powerful presentation application that allows
                          users to create visually appealing presentations
                          quickly and easily. With its range of design templates
                          and multimedia tools, PowerPoint 2021 for Professional
                          helps users create engaging and professional
                          presentations that can captivate an audience. The
                          software's built-in Presenter View feature is
                          particularly useful for those giving presentations, as
                          it allows them to view notes and control the
                          presentation from their device.
                        </p>
                      </Col>
                    </Row>
                  </div>
                  <div className="proDescription_other_products mb-3">
                    <Row>
                      <Col xl="2">
                        <div className="text-center ">
                          <img src={noteImg} alt="noteImg" />
                        </div>
                      </Col>
                      <Col xl="10 d-flex flex-column justify-content-center">
                        <p className="microsoft_description">
                          <span className="other_product_title">
                            OneNote 2021 (For Mac)
                          </span>{" "}
                          includes a range of new and improved features, such as
                          improved accessibility options, new search
                          functionality, and the ability to insert audio
                          recordings and videos into notes. Additionally,
                          OneNote 2021 includes a range of collaboration tools
                          that allow users to share notes with others.
                        </p>
                      </Col>
                    </Row>
                  </div>
                  <p className="microsoft_description">
                    Overall, Microsoft Office 2021 Home and Student is a
                    powerful productivity suite that offers a range of new and
                    improved features designed to enhance productivity and
                    streamline work. Its compatibility with other platforms and
                    devices, modern interface, and range of customization
                    options make it an ideal tool for students and home users
                    who need to create professional documents, spreadsheets, and
                    presentations quickly and efficiently.
                  </p>
                </div>
                <div className="product_accordion mt-5 me-3">
                  <Accordion>
                    <Accordion.Item eventKey="0" className=" box_shadow">
                      <Accordion.Header>
                        What is a digital download?
                      </Accordion.Header>
                      <Accordion.Body>
                        A digital download is an electronic version of your
                        software product which gives you access to download and
                        use your software immediately. This means a physical
                        package is not included with your purchase. You will
                        have the option to create a disc or USB at home or in
                        the office. Our support team would be happy to help
                        guide you through the process.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="1" className=" box_shadow">
                      <Accordion.Header>
                        What is the difference between OEM & Retail licenses?
                      </Accordion.Header>
                      <Accordion.Body>
                        OEM licenses are pre-installed on the device and are
                        backed by the vendor. Retail licenses are powered by
                        Microsoft. You are free to install your product on any
                        device. Retail versions may be transferred to new
                        hardware but may only be installed on one device at a
                        time.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="2" className=" box_shadow">
                      <Accordion.Header>
                        How can I guarantee that my copy of Microsoft software
                        is authentic?
                      </Accordion.Header>
                      <Accordion.Body>
                        Liberty Programs only purchases and distributes software
                        and licensing keys through our trusted Microsoft Partner
                        vendors. <br />
                        Any software purchased from Liberty Programs is covered
                        by our hassle-free 90-day money-back guarantee. We
                        encourage all of our customers to register their
                        Microsoft product key via the Microsoft phone activation
                        to ensure authenticity of their purchased products.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="3" className=" box_shadow">
                      <Accordion.Header>
                        Will my license key expire?
                      </Accordion.Header>
                      <Accordion.Body>
                        No, any product purchased from Liberty Programs is a
                        retail version which includes a lifetime license of your
                        software.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="4" className=" box_shadow">
                      <Accordion.Header>
                        How long until I recieve my order?
                      </Accordion.Header>
                      <Accordion.Body>
                        Your order will typically be processed immediately.
                        Please login in to your account area with the
                        credentials given during the checkout process to find
                        your download media and license keys.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="5" className=" box_shadow">
                      <Accordion.Header>
                        How do I download my software?
                      </Accordion.Header>
                      <Accordion.Body>
                        You can access your download media for your purchased
                        software in your account area.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="6" className=" box_shadow">
                      <Accordion.Header>
                        Where can I find the license keys to activate my
                        software
                      </Accordion.Header>
                      <Accordion.Body>
                        You can access your license key for your purchased
                        products in your account area.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="7" className=" box_shadow">
                      <Accordion.Header>
                        How do I get help with my installation?
                      </Accordion.Header>
                      <Accordion.Body>
                        We offer a step-by-step PDF document that walks you
                        through the download process . If you need more
                        assistance please contact our support team and we would
                        be happy to help you with the installation via chat or
                        remote installation.
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </div>
              </Col>
              <Col xxl="3" md="3" sm="12">
                <div className="product_sidebar_widget darkblue_bg box_shadow">
                  <h4>256-bit SSL Encrypted Checkout</h4>
                  <p>
                    All personal information is protected by state of the art
                    SSL certified encryption.{" "}
                  </p>
                  <hr />
                  <h4>24/7 Tech Support Available</h4>
                  <p>
                    Your purchase with Liberty Programs includes around the
                    clock support from our technical experts. <br />
                    <br />
                    Our team of highly trained professionals make software
                    installations a breeze, helping to identify problems and
                    provide immediate solutions that may arise during and after
                    the installation of software.
                  </p>
                  <hr />
                  <h4>Your Business Is Important To Us</h4>
                  <p>
                    We value our customers and appreciate your business with us.
                    <br />
                    <br />
                    Whether you're an individual upgrading your software or a
                    business upgrading their network, we're here 24/7 to provide
                    hands on support and troubleshooting.
                    <br />
                    <br />
                    All software downloads are provided directly from Microsoft
                    with a genuine license key for activation. <br />
                    <br />
                    If you have any concerns regarding the authenticity of your
                    software, please call (833) 465 0300 or contact us via chat
                  </p>
                  <hr />
                  <h4>90-Day Money Back Guarantee</h4>
                  <p>
                    If for any reason you are not completely satisfied with your
                    purchase from us please contact our refund department
                    directly at sales@libertyprograms.com
                    <br />
                    <br />
                    If we cannot resolve your ticket, a full refund will be
                    issued regardless of our 90-day money back guarantee. <br />
                    <br />
                    Terms & conditions apply.
                  </p>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </>
  );
};

export default OfficeStudentMac;
